export default __webpack_public_path__ + "static/media/pic4.7cffa600.png";